import ResultIcon from 'app/components/tests/result/ResultIcon';
import SelectForm from 'app/commons/components/SelectForm';
import * as testConst from 'app/constants/tests';
import { Question } from 'types/test';
import { useMemo } from 'react';

interface QuestionSelectProps {
  question: Question;
  groupType: number;
  options: string[];
  className: string;
  confirmIsReady: () => void;
  handleChange: (value: string | null, question: Question) => void
}

const QuestionSelect = (props: QuestionSelectProps) => {
  if (props.groupType !== testConst.QUESTION_OPTION) return null;

  const optionSelect = useMemo(() => {
    return props.options.map((label: string) => {
      const value = label.split('##')[0];
      return <option value={value} key={label}>{value}</option>;
    });
  }, [props.options]);

  return (
    <div onClick={props.confirmIsReady} className="col-md-4 pl-0 d-flex">
      <div style={{ width: '200px', flexShrink: 0 }}>
        <SelectForm
          value={props.question?.answer || ''}
          options={optionSelect}
          className={props.className}
          handleChange={(value: string) => props.handleChange(value, props.question)}
        />
      </div>

      <ResultIcon
        groupType={props.groupType}
        question={props.question}
      />
    </div>
  );
};

export default QuestionSelect;
